<div class="dropdown">
  @if (MENU_CONTENT.childElementCount > 0) {
    <button
      [disabled]="disabled"
      [id]="buttonId"
      class="btn btn-ignore px-1 dropdown-toggle"
      data-bs-toggle="dropdown"
      [attr.aria-controls]="dropdownListId"
      type="button"
    >
      <i class="fa-solid fa-ellipsis-vertical"></i>
    </button>
  }
  <div
    #MENU_CONTENT
    class="dropdown-menu dropdown-menu-end dropdown-menu-lg-{{ placement }}"
    [id]="dropdownListId"
    role="menu"
    [attr.aria-labelledby]="buttonId"
  >
    <ng-content></ng-content>
  </div>
</div>
